import type { QuickViewAction } from "../types"
import { daysBetween } from "./dates"

// An action marked on the graphs, numbered 1 for the oldest so it keeps its
// number on every graph and every Day, Week or Month.
export interface NumberedAction extends QuickViewAction {
  n: number
}

// The actions on one point of a graph, x being that point's position.
export interface ActionMark {
  x: number
  actions: NumberedAction[]
}

export function numberActions(actions: QuickViewAction[]): NumberedAction[] {
  return actions.map((action, i) => ({ ...action, n: i + 1 }))
}

// The number(s) shown in an action circle: "1", "1, 2", or "1–3" when three
// or more actions fall on the same point.
export function badgeText(actions: NumberedAction[]): string {
  const ns = actions.map((a) => a.n)
  return ns.length > 2 ? `${ns[0]}–${ns[ns.length - 1]}` : ns.join(", ")
}

// Marks for the stock graph, whose point N is today + N: the actions dated
// from today to the graph's last day.
export function stockMarks(actions: NumberedAction[], today: string, last: number): ActionMark[] {
  const byDay = new Map<number, NumberedAction[]>()
  for (const action of actions) {
    const day = daysBetween(today, action.date)
    if (day >= 0 && day <= last) byDay.set(day, [...(byDay.get(day) ?? []), action])
  }
  return [...byDay.entries()].map(([x, list]) => ({ x, actions: list }))
}
